import React from 'react';
import Tippy from '@tippy.js/react';
import 'tippy.js/dist/tippy.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const spanStyle = {
  display: 'inline-block',
  cursor: 'pointer',
};

const CroppingToolTip = () => (
  <Tippy
    appendTo={ref => {
      return ref.parentNode;
    }}
    trigger="click"
    arrow="true"
    placement="right"
    content="
                Crop original image to fit image containers using post-processing. This option
                is useful in scenarios where original image aspect ratios vary."
  >
    <span style={spanStyle} onClick={e => e.preventDefault()}>
      <FontAwesomeIcon icon="question-circle" />
    </span>
  </Tippy>
);

export default CroppingToolTip;



// WEBPACK FOOTER //
// ./src/components/Sidebar/croppingToolTip.js